<p-table [value]="batch_import_suppliers"
         [columns]="cols"
         [rows]="10"
         [paginator]="true"
         responsiveLayout="scroll">

    <ng-template pTemplate="caption">
        <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 class="m-0">Estado de la Importación</h5>
            <span class="block mt-2 md:mt-0 p-input-icon-left">
                <i class="pi pi-search"></i>
                <input pInputText type="text" (input)="onGlobalFilter(dt, $event)" placeholder="Search..."  class="w-full sm:w-auto"/>
            </span>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th style="width: 3rem">
                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
            <th>Nombre del Archivo</th>
            <th>Status</th>
            <th>Registros Procesables</th>
            <th>Total de Registros</th>
            <th>Registros con Errores</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-batchImportSupplier>
        <tr>
            <td><p-tableCheckbox [value]="batchImportSupplier"></p-tableCheckbox></td>
            <td>{{batchImportSupplier.original_file_name}}</td>
            <td>{{batchImportSupplier.status}}</td>
            <td>{{batchImportSupplier.processable_records}}</td>
            <td>{{batchImportSupplier.total_records}}</td>
            <td>
                <div *ngIf="batchImportSupplier.total_error_records > 0">
                    <button pButton pRipple icon="pi pi-times" class="p-button-text" [routerLink]="batchImportSupplier.uuid">
                        {{batchImportSupplier.total_error_records}}
                    </button>
                </div>
                <div *ngIf="batchImportSupplier.total_error_records == 0">0</div>
            </td>
        </tr>
    </ng-template>
</p-table>
